import { validate } from '../validate'

/**
 * All we need to generate a form item in edit form
 * Note for param `rules`:
 * - Support boolean, string and custom validation method
 * - Custom validation method must be compatible with `async-validator` library
 * @param {string} label - Field label
 * @param {string} key - Key in resource object
 * @param {various} rules - Validation rules
 * @param {object} on - Event listeners
 * @param {object} options - Other options, please refer to the docs
 */
export default function Field(label, key, rules, options = {}, on = {}) {
  this.label = label
  this.key = key

  if (typeof rules === 'boolean' && rules) {
    // required
    this.rule = {
      [key]: [validate.required(label)]
    }
  } else if (validate[rules]) {
    // a validation method
    this.rule = {
      [key]: [validate[rules](label)]
    }
  } else if (Array.isArray(rules)) {
    // a set of validation methods
    this.rule = {
      [key]: rules.map(item => validate[item] ? validate[item](label) : item)
    }
  } else if (typeof rules === 'object') {
    this.rule = {
      [key]: [rules]
    }
  }
  
  this.on = { ...on }
  this.options = { ...options }
}



// WEBPACK FOOTER //
// ./packages/helper/fields/Field.js